import React from "react";
import Image from "react-bootstrap/Image";

import { Link } from "react-router-dom";

import badge1 from "../images/paket_01.png";
import badge2 from "../images/paket_02.png";
import badge3 from "../images/paket_03.png";

interface IMembershipBadgeProps {
  level: number;
}

export default function MembershipBadge(props: IMembershipBadgeProps) {
  let bdg = badge1;
  let text = "Vertragstyp #1";

  if (props.level === 3) {
    bdg = badge3;
    text = "PREMIUM";
  }

  if (props.level === 2) {
    bdg = badge2;
    text = "Vertragstyp #2";
  }

  // Temporarily remove badge
  return (
    <>
      <span />
    </>
  );

  return (
    <Link to="/account" className="membership-badge">
      {text}

      <div className="membership--sign">
        <Image id="kvalogo" src={bdg} alt="Vertragslevel" fluid />
      </div>
    </Link>
  );
}
